import MuiMenuItem, { MenuItemProps as MuiMenuItemProps } from '@material-ui/core/MenuItem';
import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

import { SIZE } from '../../constants';
import useStyles from './styles';

interface MenuItemProps extends MuiMenuItemProps {
  href?: string;
  isDisabled?: boolean;
  isExternalLink?: boolean;
  isLink?: boolean;
  noPadding?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  size?: 'small' | 'medium';
  target?: '_blank';
  to?: string;
  button?: true | undefined;
  className?: string;
}

export const MenuItem: React.FC<MenuItemProps> = ({
  href,
  isDisabled = false,
  isExternalLink = false,
  isLink = false,
  size = 'medium',
  target,
  to,
  noPadding = false,
  children,
  className,
  ...otherProps
}) => {
  const classes = useStyles({
    height: SIZE[size],
    isLink: isLink || (isExternalLink && !isDisabled),
    noPadding,
  });

  const props = {
    className: classNames(classes.menuItem, className),
    disableRipple: true,
    ...otherProps,
  };

  if (isExternalLink && !isDisabled) {
    return (
      <MuiMenuItem {...props}>
        <a href={href} target={target}>
          {children}
        </a>
      </MuiMenuItem>
    );
  }
  if (isLink) {
    return (
      <MuiMenuItem {...props}>
        <Link to={to ?? ''}>{children}</Link>
      </MuiMenuItem>
    );
  }
  return <MuiMenuItem {...props}>{children}</MuiMenuItem>;
};

export default MenuItem;
